import React, { useEffect, useState } from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { cn } from "../lib/utils";

const YearPicker = ({ range = 50, onChange, value, className }) => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(value);

  // Generate years based on props
  const years = [];
  for (let y = currentYear - range; y <= currentYear + range; y++) {
    years.push(y);
  }

  const handleChange = (val) => {
    setYear(val);
    if (onChange) onChange(val);
  };

  useEffect(() => {
    setYear(value)
  },[value])

  return (
    <div className={cn(`w-full`, className)}>
      <Select value={year} onValueChange={handleChange}>
        <SelectTrigger>
          <SelectValue placeholder="Select Year" />
        </SelectTrigger>
        <SelectContent className="max-h-64">
          {years.map((y) => (
            <SelectItem key={y} value={y}>
              {y}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};

export default YearPicker;
